/**
 * used to format endpoints for local or dev
 * @param   {string}  endpoint to go to or gain access to some service
 * @returns {string}
 */
export const setEndpoint = (endpoint = '') => {
  return `${import.meta.env.VITE_INSIGHTS_ENDPOINT}/${endpoint}`;
};
